import React from 'react'
import "./Responsive.css"
export default function Topnavbar() {
  return (
    <div className='top_nav'>
     <img src="https://www.beautybebo.com/pub/media/ads/ad-desktop.jpg"/>
    </div>
  )
}
